import React from 'react';
import PropTypes from 'prop-types'
import {findDOMNode} from "react-dom"

import ProjectStatusManager from '../../../gd/manager/project-status-manager'
import ProjectStatusSelectorPopover from "./popover"
import PopoverPosition from "../../../gd-components/gd-popover/popover-position"
import {ProjectSystemType} from "../../../model2/project/types"

export default class ProjectStatusSelector extends React.Component {
    static propTypes = {
        projectId: PropTypes.string.isRequired,         // project id
        value: PropTypes.any,                           // current statusId: string for statusId, number for systemStatus

        placeholder: PropTypes.string,                  // can be used when no status i.e. re-open task (hotya tam mozno i pervii kstati brat' avtomatom !


        // optional fields that used when no project found in session i.e. for archived projects in projects all list
        projectSystemStatus: PropTypes.number,
        projectSystemType: PropTypes.number,


        // callbacks
        onUserSelect: PropTypes.func,
        onChange: PropTypes.func,
        onTogglePopover: PropTypes.func,                // hez zachem no vezde est'

        // look and feel
        renderValue: PropTypes.oneOf(
            ['color-block-26', 'color-round-block-22', 'project-view', 'project-view-inline',
                'inline', 'table-inline', 'form', 'func', 'ui5']).isRequired, // render value view name
        renderValueFunc: PropTypes.func,                // func for external render function if passwed used to render instead of default

        // options: PropTypes.array.isRequired,
        disabled: PropTypes.bool,                       // if true not editable (!) just view maybe right name is editable not disabled ?
        makeApiCalls: PropTypes.bool,                   // make calls to backend on status change confirmed

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string
    };

    static defaultProps = {
        placeholder: 'Select status',

        disabled: false,
        makeApiCalls: true,

        attachment: "top right",
        targetAttachment: "top left",
        targetOffset: "-60 0"
    };

    state = {
        showPopover: false,
        value: this.props.value
    };

    getStatus = (value) => {
        let res = null;

        const project = gd.session.projects.get(this.props.projectId);
        const projectSystemType = this.props.projectSystemType ? this.props.projectSystemType : project.systemType;

        // switch (project.systemType) {
        switch (projectSystemType) {
            case ProjectSystemType.PROJECT:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
                res = gd.session.statuses.get(value)

                if (!res) {
                    const defaultStatuses = ProjectStatusManager.getDefaultStatuses();
                    res =_.find(defaultStatuses, ps=>ps.id === value);
                }
                break;

            // case ProjectSystemType.TAG:
            // case ProjectSystemType.FOLDER:
            // case ProjectSystemType.PAGE:
            default:
                const defaultStatuses = ProjectStatusManager.getDefaultStatuses(projectSystemType);
                res =_.find(defaultStatuses, ps=>ps.id === value);
                break;
        }

        return res;
    };

    // Checkbox
    onCheckboxClick = (e) => {
        const { COMPLETED, CANCELLED } = gd.const.systemStatus;
        const { value } = this.state;
        e.stopPropagation();

        // ok we clicked checkbox
        const status = gd.session.statuses.get(value);
        let newStatus;

        const projectStatuses = this.getStatuses();

        if (gd.const.systemStatus.isOpen(status.systemStatus)) {

            // we need to close - find closed statuses
            const orderedClosedStatuses = _.chain(projectStatuses)
                .filter(m=>m.systemStatus === COMPLETED || m.systemStatus === CANCELLED)
                .sortBy("status.systemStatus")
                .value();

            newStatus = orderedClosedStatuses[0].id;
        } else {
            // we need to reopen
            const orderedOpenStatuses = _.chain(projectStatuses)
                .filter(m=>m.systemStatus !== COMPLETED && m.systemStatus !== CANCELLED)
                .sortBy("status.systemStatus")
                .value();
            newStatus = orderedOpenStatuses[0].id;
        }

        this.onStatusClick(newStatus);
    };

    // if rerender with new value
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value){
            this.setState({
                value: nextProps.value
            });
        }
    }

    preventPropagation = (e) => {
        e.stopPropagation();
    };

    togglePopover = () => {
        if (!this.props.disabled) {
            const showPopover = !this.state.showPopover;
            this.setState({
                showPopover: showPopover
            },()=>{
                if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover);
            });
        }
    };

    hidePopover = (value) => {
        let { onTogglePopover } = this.props;
        this.setState({
            showPopover: false,
            value: value ? value : this.state.value
        });
        if (onTogglePopover) onTogglePopover(false);
    };

    onStatusClick = (value) => {
        const prevValue = this.state.value;
        this.setState({
            showPopover: false,
            // value: value
        }, ()=>{
            if (this.props.makeApiCalls) {
                this.onStatusSelect(value, (v, statusUpdateCallDone)=>{
                    this.setState({value: v}, ()=>{this.confirmStatusSelection(prevValue, v, statusUpdateCallDone)});
                });
            } else {
                this.setState({value: value}, ()=>{this.confirmStatusSelection(prevValue, value)});
            }
        });
    };

    onStatusSelect = (val, callback) => {
        const { projectId } = this.props;
        const project = gd.session.projects.get(projectId);

        const projectSystemType = (this.props.projectSystemType)?this.props.projectSystemType:project.systemType;

        let oldValue, res;
        // switch (project.systemType) {
        switch (projectSystemType) {
            case ProjectSystemType.PROJECT:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
                oldValue = (project)?project.statusId:null;
                if (oldValue !== val) {
                    res = res = gd.api.Project.updateStatus(project.id,val,false);

                    res.done((data)=>{
                        if (data === 'not-empty') {
                            gd.modals.project.confirmCloseNotEmpty(projectId, val, null, accepted=>{callback(accepted ? val : oldValue), false});
                        } else {
                            callback(val, true);
                        }
                    });
                }
                break;

            // case ProjectSystemType.FOLDER:
            // case ProjectSystemType.TAG:
            // case ProjectSystemType.PAGE:
            default:
                oldValue = (project)?project.systemStatus:null;
                if (oldValue !== val) {
                    res = gd.api.Project.updateSystemStatus(project.id,val,false);

                    res.done((data)=>{
                        if (data === 'not-empty') {
                            gd.modals.project.confirmCloseNotEmpty(projectId, null, val, accepted=>{callback(accepted ? val : oldValue, false)});
                        } else {
                            callback(val, true);
                        }
                    });
                }
                break;
        }
    };

    _commitChange = (status) => {
        const { projectId } = this.props;

        const project = gd.session.projects.get(projectId);

        const projectSystemType = (this.props.projectSystemType)?this.props.projectSystemType:project.systemType;

        switch (projectSystemType) {
        // switch (project.systemType) {
            case ProjectSystemType.PROJECT:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
                gd.api.Project.updateStatus(projectId,status,true);
                break;

            // case ProjectSystemType.FOLDER:
            // case ProjectSystemType.TAG:
            // case ProjectSystemType.PAGE:
            default:
                gd.api.Project.updateSystemStatus(projectId,status,true);
                break;
        }
    }

    confirmStatusSelection = (prevValue, value, statusUpdateCallDone = false) => {
        if (this.props.makeApiCalls && !statusUpdateCallDone) this._commitChange(value);
        if (this.props.onChange) this.props.onChange(prevValue, value); // of fck ... someone passes OLD value first.... be careful !
    };

    renderPopover = () => {
        if (this.state.showPopover) {
            const popoverPosition = new PopoverPosition({
                attachment          : this.props.attachment,
                targetAttachment    : this.props.targetAttachment,
                targetOffset        : this.props.targetOffset,
            })

            const project = gd.session.projects.get(this.props.projectId)

            return <ProjectStatusSelectorPopover hidePopover        = {this.hidePopover}
                                                 projectSystemType  = {this.props.projectSystemType}
                                                 project            = {project}
                                                 onStatusSelect     = {this.onStatusClick}
                                                 togglePopover      = {this.togglePopover}
                                                 hint               = {this.props.hint}
                                                 popoverPosition    = {popoverPosition}
                                                 getTarget          = {()=>findDOMNode(this)}/>
        }
    };

    renderValue = () => {
        const { renderValue, placeholder } = this.props;
        const { value } = this.state;
        // value label
        let valueLabel = placeholder;
        let statusColor = 1;
        let isOpen = true;

        if (value) {
            const status = this.getStatus(value);

            if (status) {
                valueLabel = status.name;
                statusColor = status.color;
                isOpen = gd.const.systemStatus.isOpen(status.systemStatus);
            }
        }

        let curValueClasses;

        let checkboxValue = false;

        switch (renderValue) {

            case 'table-inline':
                curValueClasses = Classes('cur-value', 'table-inline-type', 'gd-scf-'+statusColor);

                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        <div className="name">{valueLabel}</div>
                    </div>
                );

            case 'inline':
                curValueClasses = Classes('cur-value', 'project-header', 'gd-scf-'+statusColor);

                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>
                    </div>
                );

            case 'form':
                curValueClasses = Classes('cur-value', 'form', 'gd-scf-'+statusColor);

                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>
                    </div>
                );

            case 'project-view':
                curValueClasses = Classes('cur-value',  'project-view', 'status-color-'+statusColor );

                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        {/*<div className="checkbox" onClick={this.onCheckboxClick}>{checkboxValue}</div>*/}
                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>
                    </div>
                );

            case 'project-view-inline':
                curValueClasses = Classes('cur-value', 'project-view-inline', 'gd-scf-'+statusColor );

                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        {!this.props.disabled &&
                        <div className="checkbox" onClick={this.onCheckboxClick}>{checkboxValue}</div>}
                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>
                    </div>
                );

            case 'color-block-26':
                curValueClasses = Classes('cur-value', 'color-block-26', 'status-color-'+statusColor );

                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                const checkboxClasses = (isOpen)?'checkbox':'checkbox checked';

                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        <div className={checkboxClasses} onClick={this.onCheckboxClick}>{checkboxValue}</div>
                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>
                    </div>
                );

            case 'color-round-block-22':
                curValueClasses = Classes('cur-value', 'color-round-block-22', 'status-color-'+statusColor );

                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        <div className="name">{valueLabel}</div>
                    </div>
                );

            case 'ui5':
                curValueClasses = Classes('ui5-status-list', 'status-c{0}'.f(statusColor));
                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        {valueLabel}
                    </div>
                );
        }
    };

    render() {
        const classes = Classes('gd-select-status', 'project', this.props.className, {
            'popover-shown': this.state.showPopover,
            disabled: this.props.disabled
        });

        return (
            <div className={classes} onClick={!this.props.disabled ? this.preventPropagation : null}>
                {this.renderValue()}
                {this.renderPopover()}
            </div>
        );
    }
}
